.quickNavigation {
  [class='ant-modal-content'] {
    background-color: transparent;
    border-radius: 0;
  }
}

.dialog {
  position: absolute;
  top: 8%;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1000;
  max-width: 600px;
  width: 100%;
  min-height: 450px;
  padding: var(--padding-xs);
  background: var(--color-bg-base);
  border-radius: 0.9rem;
  overflow: hidden;
  border: 1px solid var(--color-border);
  box-shadow: var(--box-shadow);
  transition: transform 100ms ease;
  outline: none;
}

.palette {
  [cmdk-input] {
    border: none;
    width: 100%;
    font-size: 17px;
    padding: var(--padding-xs) 0.5rem 1rem 0.5rem;
    outline: none;
    background: var(--color-bg-base);
    color: var(--color-text);
    border-bottom: 1px solid var(--color-border);
    margin-bottom: 1rem;
    border-radius: 0;

    &::placeholder {
      color: var(--color-text-placeholder);
    }
  }

  [cmdk-item] {
    content-visibility: auto;
    cursor: pointer;
    min-height: 48px;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 0.5rem;
    padding: 0 1rem;
    color: var(--color-bg-mask);
    user-select: none;
    will-change: background, color;
    transition: all 150ms ease;
    transition-property: none;

    &[data-selected='true'] {
      background: var(--color-fill-quaternary);
      color: var(--color-text);
    }

    &[data-disabled='true'] {
      color: var(--color-text-disabled);
      cursor: not-allowed;
    }

    &:active {
      transition-property: background;
      background: var(--color-border);
    }

    & + [cmdk-item] {
      margin-top: 0.25rem;
    }
    div > .itemExtraInfo {
      color: var(--color-text-description);
    }
  }

  [cmdk-list] {
    height: min(330px, calc(var(--cmdk-list-height)));
    max-height: 400px;
    overflow: auto;
    overscroll-behavior: contain;
    transition: 100ms ease;
    transition-property: height;
  }

  [cmdk-separator] {
    height: 1px;
    width: 100%;
    background: var(--color-border);
    margin: 0.25rem 0;
  }

  *:not([hidden]) + [cmdk-group] {
    margin-top: 0.5rem;
  }

  [cmdk-group-items] {
    display: flex;
    flex-direction: column;
  }

  [cmdk-group-heading] {
    user-select: none;
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: var(--color-bg-mask);
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  [cmdk-empty] {
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    white-space: pre-wrap;
    color: var(--color-bg-mask);
  }
}
